import script from "./PortfolioIndexes.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioIndexes.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioIndexes.vue?vue&type=style&index=0&id=17527e65&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17527e65"]])

export default __exports__